import { ListItemIcon, Menu, MenuItem } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBolt, faPen } from "@fortawesome/pro-light-svg-icons"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"

const useStyles = makeStyles()((theme) => ({
    menuPaper: {
        minWidth: "14rem",
        borderRadius: ".75rem",
    },
    menuItem: {
        "&.MuiMenuItem-root": {
            minHeight: "auto",
            paddingTop: ".75rem",
            paddingBottom: ".75rem",
        },
    },
    itemIcon: {
        minWidth: "2rem",
        color: theme.palette.tailwind.slate[500],
    },
}))

type Props = Readonly<{
    anchorEl: HTMLElement | null
    onClose: () => void
    onQuickEdit: () => void
    onFullEdit: () => void
}>

export function OrderEditMenu({ anchorEl, onClose, onQuickEdit, onFullEdit }: Props) {
    const { classes } = useStyles()

    const runAndClose = (action: () => void) => () => {
        action()
        onClose()
    }

    return (
        <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={onClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            slotProps={{ paper: { className: classes.menuPaper } }}
        >
            <MenuItem className={classes.menuItem} onClick={runAndClose(onQuickEdit)}>
                <ListItemIcon className={classes.itemIcon}>
                    <FontAwesomeIcon icon={faBolt} />
                </ListItemIcon>
                <LocalizedStrict id="meeting-service-order-drawer-quick-edit">
                    <span>Quick edit</span>
                </LocalizedStrict>
            </MenuItem>
            <MenuItem className={classes.menuItem} onClick={runAndClose(onFullEdit)}>
                <ListItemIcon className={classes.itemIcon}>
                    <FontAwesomeIcon icon={faPen} />
                </ListItemIcon>
                <LocalizedStrict id="meeting-service-order-drawer-full-edit">
                    <span>Full edit</span>
                </LocalizedStrict>
            </MenuItem>
        </Menu>
    )
}
